import React from "react";
import { FlaskConical } from "lucide-react";
import { useLang } from "@/i18n";

/**
 * D3-Phase-B — small inline indicator rendered next to any object the
 * backend tagged with `_demo_state: "created" | "modified"`.
 *
 * The badge is intentionally tiny and non-invasive: a purple pill with
 * a flask icon plus a one-word label. The colour is dedicated to demo
 * state so it doesn't collide with the existing emerald (success),
 * amber (warning), or rose (error) accents used in the app.
 *
 * Renders nothing when `state` is falsy, so callers can drop it in
 * unconditionally:
 *
 *     <DemoWriteBadge state={wl._demo_state} />
 */
export const DemoWriteBadge = ({ state, className = "" }) => {
  const { t } = useLang();
  if (!state) return null;
  const label = state === "created"
    ? t("demoBadge.created")
    : t("demoBadge.modified");
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-purple-50 border border-purple-200 px-2 py-0.5 text-[10px] font-semibold text-purple-700 ${className}`}
      data-testid={`demo-write-badge-${state}`}
      title={label}
    >
      <FlaskConical className="w-3 h-3" />
      {label}
    </span>
  );
};

export default DemoWriteBadge;
